import Table from '@components/table'
const Withdrawal = () => {
  const columns = [
    {
      title: 'Transaction Id',
      key: 'id',
    },
    {
      title: 'Amount',
      key: 'amount',
    },
    {
      title: 'Platform Charge',
      key: 'platformCharge',
    },

    {
      title: 'Date',
      key: 'date',
    },
    {
      title: 'Payment Status',
      key: 'status',
    },
    {
      title: 'Remarks',
      key: 'remarks',
    },
  ]
  return <Table columns={columns} />
}

export default Withdrawal
